// Auth routes
export const AUTH_ROUTES = {
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  OAUTH_CALLBACK: "/auth/callback",
  PENDING_APPROVAL: "/pending-approval",
  VERIFY_EMAIL: "/verify-email",
} as const;

// Dashboard routes by role
export const DASHBOARD_ROUTES = {
  STUDENT: "/dashboard",
  HR_STAFF: "/hr",
  ENTERPRISE_RECRUITER: "/enterprise",
  ADMIN: "/admin",
} as const;

// OAuth providers
export const OAUTH_PROVIDERS = {
  ZENCUBE: "zencube",
} as const;

// Session storage keys
export const STORAGE_KEYS = {
  OAUTH_CODE_VERIFIER: "tr_oauth_code_verifier",
  OAUTH_STATE: "tr_oauth_state",
  OAUTH_RETURN_TO: "tr_oauth_return_to",
  OAUTH_FLOW_ACTIVE: "tr_oauth_flow_active",
} as const;

// Auth messages
export const AUTH_MESSAGES = {
  LOGIN_SUCCESS: "Welcome back!",
  LOGOUT_SUCCESS: "You have been logged out.",
  REGISTER_SUCCESS: "Account created! Please check your email for verification.",
  PASSWORD_RESET_SENT: "Password reset instructions sent to your email.",
  SESSION_EXPIRED: "Your session has expired. Please log in again.",
  INVALID_CREDENTIALS: "Invalid email or password.",
  ACCOUNT_LOCKED: "Account is locked. Try again later.",
  EMAIL_NOT_VERIFIED: "Please verify your email before logging in.",
} as const;

// Password requirements (for display)
export const PASSWORD_REQUIREMENTS = [
  { label: "At least 8 characters", regex: /.{8,}/ },
  { label: "One uppercase letter", regex: /[A-Z]/ },
  { label: "One lowercase letter", regex: /[a-z]/ },
  { label: "One digit", regex: /[0-9]/ },
  { label: "One special character", regex: /[^A-Za-z0-9]/ },
] as const;
